import { PlusIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Button, Loading } from '@/components/ui/daisy';
import useFormList from '@/data/hook/shared/useFormList';
import LessonInlineForm from './LessonInlineForm';

type CreateLessonData = {
  name: string;
  description?: string;
  order: number;
};

type LessonFormListProps = {
  lessonsCount: number;
  onSubmit: (data: CreateLessonData) => void;
  isLoading: boolean;
};

export default function LessonFormList({
  lessonsCount,
  onSubmit,
  isLoading,
}: LessonFormListProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.lessonsTab',
  });
  const { openForms, addForm, removeForm, handleFormSubmit } =
    useFormList<CreateLessonData>({ onSubmit });

  return (
    <div className="flex flex-col gap-6">
      <ConditionalRenderer condition={isLoading}>
        <FieldsetContainer className="flex justify-center items-center py-5">
          <Loading variant="spinner" size="md" color="primary" />
        </FieldsetContainer>
      </ConditionalRenderer>
      {openForms.map(formId => (
        <LessonInlineForm
          key={formId}
          onSubmit={handleFormSubmit(formId)}
          onCancel={() => removeForm(formId)}
          isLoading={isLoading}
          order={lessonsCount + 1}
        />
      ))}
      <FieldsetContainer>
        <Button size="md" onClick={addForm} className="bg-base-300">
          <PlusIcon className="w-4 h-4" />
          {t('addLesson')}
        </Button>
      </FieldsetContainer>
    </div>
  );
}
